// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pzrc29 {
  border: none;
  max-width: 560px;
  width: 100%;
  border-radius: var(--radius-m);
  outline: none;
  overflow: hidden;
  padding: 0;
}

.Pzrc29 [data-testid\$='-title'] {
  line-height: var(--type-title-lg-line-height);
}

.Pzrc29 [data-testid\$='-header'] {
  align-items: flex-start;
  padding-bottom: 0;
}

.IhcuDe {
  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3);
  width: 100%;
  box-sizing: border-box;
}

.mnZjUs {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4-5);
  align-items: stretch;
  text-align: left;
  width: 100%;
}

.jPWDaY {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  font-size: var(--type-paragraph-lg-font-size);
  line-height: var(--type-paragraph-lg-regular-line-height);
  color: var(--text-neutral-stronger);
  margin: 0;
  text-align: left;
}

.usUsIb {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-2);
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

@media (max-width: 768px) {
  .IhcuDe {
    padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3);
  }

  .mnZjUs {
    gap: var(--spacing-4-5);
  }

  .jPWDaY {
    font-size: var(--type-paragraph-md-font-size);
    font-weight: var(--type-paragraph-md-regular-font-weight);
    line-height: var(--type-paragraph-md-regular-line-height);
  }
}

@media (max-width: 480px) {
  .usUsIb {
    flex-direction: column-reverse;
    align-items: stretch;
  }
}

.VAzad9 {
  width: 400px;
  height: 200px;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  max-width: calc(100vw - 32px);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

[data-testid\$='-backdrop']:has(.VAzad9) {
  background: rgba(31, 31, 31, 0.6);
}

.VAzad9 [data-testid\$='-header'] {
  min-height: 48px;
  padding: 24px 24px 0;
  align-items: center;
}

.VAzad9 [data-testid\$='-title'] {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
}

.VAzad9 [data-testid\$='-close-button'] {
  width: 24px;
  height: 24px;
  padding: 0;
  margin-left: 0;
  flex: none;
}

.VAzad9 .IhcuDe {
  flex: 1;
  min-height: 0;
  padding: 16px 24px 24px;
}

.VAzad9 .mnZjUs {
  flex: 1;
  justify-content: space-between;
  gap: 16px;
}

.VAzad9 .jPWDaY {
  display: flex;
  align-items: center;
  flex: 1;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
}

.VAzad9 .usUsIb button {
  width: 100px;
  height: 32px;
  min-height: 32px;
  padding: 8px;
  border-width: 1px;
  --size: 14px;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BenefitsOnboardingWizard/BenefitsOnboardingWizard.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,6DAA6D;EAC/D;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6CAA6C;IAC7C,yDAAyD;IACzD,yDAAyD;EAC3D;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".skipConfirmModal {\n  border: none;\n  max-width: 560px;\n  width: 100%;\n  border-radius: var(--radius-m);\n  outline: none;\n  overflow: hidden;\n  padding: 0;\n}\n\n.skipConfirmModal :global([data-testid$='-title']) {\n  line-height: var(--type-title-lg-line-height);\n}\n\n.skipConfirmModal :global([data-testid$='-header']) {\n  align-items: flex-start;\n  padding-bottom: 0;\n}\n\n.skipConfirmBody {\n  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.skipConfirmContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4-5);\n  align-items: stretch;\n  text-align: left;\n  width: 100%;\n}\n\n.skipConfirmDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  font-size: var(--type-paragraph-lg-font-size);\n  line-height: var(--type-paragraph-lg-regular-line-height);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n  text-align: left;\n}\n\n.skipConfirmActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-2);\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .skipConfirmBody {\n    padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3);\n  }\n\n  .skipConfirmContent {\n    gap: var(--spacing-4-5);\n  }\n\n  .skipConfirmDescription {\n    font-size: var(--type-paragraph-md-font-size);\n    font-weight: var(--type-paragraph-md-regular-font-weight);\n    line-height: var(--type-paragraph-md-regular-line-height);\n  }\n}\n\n@media (max-width: 480px) {\n  .skipConfirmActions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n}\n\n.migrationSkipModal {\n  width: 400px;\n  height: 200px;\n  box-sizing: border-box;\n  border: 1px solid #f2f2f2;\n  max-width: calc(100vw - 32px);\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n}\n\n:global([data-testid$='-backdrop']):has(.migrationSkipModal) {\n  background: rgba(31, 31, 31, 0.6);\n}\n\n.migrationSkipModal :global([data-testid$='-header']) {\n  min-height: 48px;\n  padding: 24px 24px 0;\n  align-items: center;\n}\n\n.migrationSkipModal :global([data-testid$='-title']) {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.migrationSkipModal :global([data-testid$='-close-button']) {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  margin-left: 0;\n  flex: none;\n}\n\n.migrationSkipModal .skipConfirmBody {\n  flex: 1;\n  min-height: 0;\n  padding: 16px 24px 24px;\n}\n\n.migrationSkipModal .skipConfirmContent {\n  flex: 1;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.migrationSkipModal .skipConfirmDescription {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.6;\n}\n\n.migrationSkipModal .skipConfirmActions button {\n  width: 100px;\n  height: 32px;\n  min-height: 32px;\n  padding: 8px;\n  border-width: 1px;\n  --size: 14px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skipConfirmModal": `Pzrc29`,
	"skipConfirmBody": `IhcuDe`,
	"skipConfirmContent": `mnZjUs`,
	"skipConfirmDescription": `jPWDaY`,
	"skipConfirmActions": `usUsIb`,
	"migrationSkipModal": `VAzad9`
};
module.exports = ___CSS_LOADER_EXPORT___;
